// extracted by mini-css-extract-plugin
module.exports = {"base":"Footer_base__f0Dxu","hero":"Footer_hero__B8H0B","imprint":"Footer_imprint__U8kdo"};